module.exports = __webpack_public_path__ + "img/step-1.3e3cd97d.png";